import { formatAdvanceCustomStatusValue } from "components/AdvanceManagement/AdvanceCustomStatusField";
import { getCleanStartorEndDay } from "helpers/utils";
import type { IAdvanceSlice } from "store/advancePaymentSlice";
import { v4 as uuidv4 } from "uuid";

import type { TAdvancePayment } from ".";

export type TermAdvancePaymentRecord = IAdvanceSlice & { periodClosed?: boolean | number };

function isTermAdvancePaymentRecord(value: unknown): value is TermAdvancePaymentRecord {
    if (typeof value !== "object" || value === null || !("id" in value)) return false;
    if (typeof value.id !== "number") return false;
    if ("slices" in value && value.slices != null && !Array.isArray(value.slices)) return false;
    return true;
}

export function readTermAdvancePayments(payload: unknown): TermAdvancePaymentRecord[] {
    if (typeof payload !== "object" || payload === null || !("data" in payload)) return [];
    if (!Array.isArray(payload.data)) return [];
    return payload.data.filter(isTermAdvancePaymentRecord);
}

/**
 * Formats the initial slices after fetching it to fill out existing slices fields.
 * @param slices - The slices to format.
 * @returns The formatted slices.
 */
export const formatInitialSlices = (slices: TermAdvancePaymentRecord[]) => {
    const initialSlices = slices.reduce(
        (acc, item) => {
            for (const slice of item.slices ?? []) {
                acc.push({
                    ...slice,
                    isForfait: item.isForfait,
                    paymentId: item.id,
                    key: uuidv4(),
                    amount: slice.amount / 100,
                    sliceId: slice.id,
                    periodClosed: item.periodClosed ? 1 : 0,
                    paymentDate: slice.paymentDate ? getCleanStartorEndDay(slice.paymentDate) : null,
                    customStatusId: formatAdvanceCustomStatusValue(slice.customStatusId),
                });
            }
            return acc;
        },
        [] as TAdvancePayment["slices"],
    );
    return initialSlices;
};
